<template>
	<div>
		<nav class="wrap">
			<ul class="list">
				<li>
					<img src="../assets/company/1.jpg" />

				<li>
					<img src="../assets/company/2.jpg" />
				</li>
				<li>
					<img src="../assets/company/3.jpg" />
				</li>
				<li>
					<img src="../assets/company/4.jpg" />
				</li>
				<li>
					<img src="../assets/company/5.jpg" />
				</li>
				<li>
					<img src="../assets/company/6.jpg" />
				</li>
				<li>
					<img src="../assets/company/7.jpg" />
				</li>
				<li>
					<img src="../assets/company/8.jpg" />
				</li>
				<li>
					<img src="../assets/company/9.jpg" />
				</li>
				<li>
					<img src="../assets/company/10.jpg" />
				</li>
				<li>
					<img src="../assets/company/1.jpg" />

				<li>
					<img src="../assets/company/2.jpg" />
				</li>
				<li>
					<img src="../assets/company/3.jpg" />
				</li>
				<li>
					<img src="../assets/company/4.jpg" />
				</li>
			</ul>

		</nav>
		<nav class="wrap">
			<ul class="list" style="padding-left: 70px;">
				<li>
					<img src="../assets/company/11.jpg" />

				<li>
					<img src="../assets/company/12.jpg" />
				</li>
				<li>
					<img src="../assets/company/13.jpg" />
				</li>
				<li>
					<img src="../assets/company/14.jpg" />
				</li>
				<li>
					<img src="../assets/company/15.jpg" />
				</li>
				<li>
					<img src="../assets/company/16.jpg" />
				</li>
				<li>
					<img src="../assets/company/17.jpg" />
				</li>
				<li>
					<img src="../assets/company/18.jpg" />
				</li>
				<li>
					<img src="../assets/company/19.jpg" />
				</li>
				<li>
					<img src="../assets/company/20.jpg" />
				</li>
				<li>
					<img src="../assets/company/11.jpg" />

				<li>
					<img src="../assets/company/12.jpg" />
				</li>
				<li>
					<img src="../assets/company/13.jpg" />
				</li>
				<li>
					<img src="../assets/company/14.jpg" />
				</li>
			</ul>

		</nav>
		<nav class="wrap">
			<ul class="list">
				<li>
					<img src="../assets/company/21.jpg" />

				<li>
					<img src="../assets/company/22.jpg" />
				</li>
				<li>
					<img src="../assets/company/23.jpg" />
				</li>
				<li>
					<img src="../assets/company/24.jpg" />
				</li>
				<li>
					<img src="../assets/company/25.jpg" />
				</li>
				<li>
					<img src="../assets/company/26.jpg" />
				</li>
				<li>
					<img src="../assets/company/27.jpg" />
				</li>
				<li>
					<img src="../assets/company/28.jpg" />
				</li>
				<li>
					<img src="../assets/company/29.jpg" />
				</li>
				<li>
					<img src="../assets/company/30.jpg" />
				</li>
				<li>
					<img src="../assets/company/21.jpg" />

				<li>
					<img src="../assets/company/22.jpg" />
				</li>
				<li>
					<img src="../assets/company/23.jpg" />
				</li>
				<li>
					<img src="../assets/company/24.jpg" />
				</li>
			</ul>

		</nav>
	</div>
</template>

<script>
	export default {
		name: 'insureList'
	}
</script>

<style>
	.wrap {
		max-width: 1140px;
		width: 100%;
		height: 80px;
		position: relative;
		overflow: hidden;
	}

	.list {
		position: absolute;
		left: 0;
		top: 0;
		margin: 0;
		padding: 0;
		-webkit-animation: 30s move infinite linear;
		width: 4200px;
	}

	.list li {
		list-style: none;
		width: 150px;
		height: 100px;
		color: #fff;
		text-align: center;
		float: left;
	}

	.list li img {
		margin: 10px;
		width: 100px;
		height: 50px;
		border-radius: 10px;
		box-shadow: 0 4px 7px 0 hsla(0, 0%, 70.6%, .08);
	}

	@-webkit-keyframes move {
		0% {
			left: 0;
		}

		100% {
			left: -1500px;
		}
	}

	@keyframes move {
		0% {
			left: 0;
		}

		100% {
			left: -1500px;
		}
	}
</style>
